import script from "./SalaryAdvanceReview.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryAdvanceReview.vue?vue&type=script&setup=true&lang=js"

import "./SalaryAdvanceReview.vue?vue&type=style&index=0&id=61b9a12f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b9a12f"]])

export default __exports__